
import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../../../Utils/Utils'
import OneTextArea from "../../../../../Components/OneTextArea/OneTextArea"
import OneSelect from "../../../../../Components/OneSelect/OneSelect"
import { OneSwitch } from "../../../../../Components/OneSwitch/OneSwitch"
import { rowsSx } from "./SxDadosTab"
import { tipoCondominio } from "../../../../../Utils/optionsSelects"
import ConfirmModal from "../../../../../Components/ConfirmModal/ConfirmModal"
import { CondominiosContext } from "../../../../../Providers/CondominiosContext/CondominiosContext"

export const DadosTab = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit, setOnCloseChanges = () => {}, setTipoCondominioState }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { alterInfoCond } = useContext(CondominiosContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const [confirmExit, setConfirmExit] = useState(false)

    const [equipes, setEquipes] = useState(null)

    const getDadosIniciais = (msg) => {
        if (msg.cmd == "buscarListagens") {
            if (msg.data.status == true) {
                msg.data.listagens.equipe.unshift({ id: 0, descricao: "Qualquer Equipe" })
                setEquipes(msg.data.listagens.equipe)
            } else if (msg.data.status == "error") {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            } else if (msg.data.status == false) {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            }
        } else {
            if (msg.data.status) {
                setInitialData(msg.data.condominio)
                // setLoading(false)
            } else {
                showNotify(msg.message)
                setOpenCadastro(false)
            }
        }
    }

    useEffect(() => {
        if ((initialData || idToEdit == null) && equipes) {
            setLoading(false)
        }
    }, [initialData, equipes])

    useEffect(() => {
        let result = false
        for (const prop in initialData) {
            if (Object.hasOwnProperty.call(initialData, prop)) {
                if (initialData[prop] != formData[prop] && formData[prop] != undefined) {
                    if (initialData[prop] != formData[prop]) {
                        result = true
                    }
                }
            }
        }
        setOnCloseChanges(result)
        if (formData?.tipo_condominio != undefined) {
            setTipoCondominioState(formData?.tipo_condominio)
        }
    }, [formData])

    useEffect(() => {
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            setLoading(true)
            addRoute("buscarCondominio", getDadosIniciais)
            addRoute("buscarListagens", getDadosIniciais)
            sendWs("buscarCondominio", { id: stringId, listar: true })
            sendWs("buscarListagens", { listagens: { equipe: ["id", "descricao"] } })
        } else {
            // setLoading(false)
        }
    }, [])

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            setOnCloseChanges(false)
            showNotify("success", "Dados salvos com sucesso!")
            setLoading(true)
            sendWs("buscarCondominio", { id: idToEdit, listar: true })
            if (msg.data && msg.data.condominio) {
                alterInfoCond(msg.data.condominio.id_central, msg.data.condominio)
            }
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("editarCondominio", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            sendWs("editarCondominio", { condominio: data })
        }
    }

    return (
        <form
            id="condominio-form"
            onSubmit={handleSubmit}
            style={{ width: '100%' }}
        >
            {confirmExit &&
                    <ConfirmModal
                        titleText="Alterações não salvas"
                        open={confirmExit}
                        text="Você tem alterações que não foram salvas. O que deseja fazer?"
                        setOpen={setConfirmExit}
                        // cancelFunction={() => handleDescartar("descartar")}
                        cancelText="Descartar"
                        // confirmFunction={handleSaveOnChange}
                        confirmText="Salvar"
                    />
            }
            {!loading &&
            <Grid xs={12} gap={1}>
                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={1.5}>
                        <Typography fontSize="13px" fontWeight='400' >Revenda: </Typography>
                    </Grid>
                    <Grid xs={12} md>
                        <OneInput
                            defaultValue={initialData?.id_revenda_nuvem}
                            readOnly
                            maxLength="4"
                            required
                            onChange={handleChange}
                            name={"id_revenda_nuvem"}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} >
                    <Grid xs={12} md={3}>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={6.2}>
                                <Typography fontSize="13px" fontWeight='400' >Conta: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneInput
                                    defaultValue={initialData?.id_central}
                                    readOnly
                                    maxLength="6"
                                    required
                                    onChange={handleChange}
                                    name={"id_central"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={1.5}>
                                <Typography fontSize="13px" fontWeight='400' >Apelido: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneInput
                                    defaultValue={initialData?.apelido}
                                    maxLength="30"
                                    onChange={handleChange}
                                    name={"apelido"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={1.5}>
                        <Typography fontSize="13px" fontWeight='400' >Nome: </Typography>
                    </Grid>
                    <Grid xs={12} md>
                        <OneInput
                            defaultValue={initialData?.nome}
                            maxLength="50"
                            onChange={handleChange}
                            name={"nome"}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={1.5}>
                        <Typography fontSize="13px" fontWeight='400' >Endereço: </Typography>
                    </Grid>
                    <Grid xs={12} md>
                        <OneInput
                            defaultValue={initialData?.endereco}
                            maxLength="150"
                            onChange={handleChange}
                            name={"endereco"}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} >
                    <Grid xs={12} md={6}>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={3}>
                                <Typography fontSize="13px" fontWeight='400' >Equipe: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneSelect
                                    options={equipes}
                                    defaultValue={initialData?.id_equipe}
                                    onChange={handleChange}
                                    name={"id_equipe"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md>
                        <Grid container xs={12} md={6} sx={rowsSx}>
                            <Grid xs={12} md={3}>
                                <Typography fontSize="13px" fontWeight='400' sx={{ textAlign: { md: 'end', xs: '' }, paddingRight: '5px' }} >Tipo: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneSelect
                                    options={tipoCondominio}
                                    defaultValue={initialData?.tipo_condominio || 1}
                                    onChange={handleChange}
                                    name={"tipo_condominio"}
                                    valor={"value"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} >
                    <Grid container xs={12} md={12} sx={rowsSx}>
                        <Grid xs={12} md={4}>
                            <Typography fontSize="13px" fontWeight='400' >Liberação Padrão:</Typography>
                        </Grid>
                        <Grid xs={12} md>
                            <OneSelect
                                placeholder="Liberar acesso até"
                                defaultValue={initialData?.liberacao_padrao_visitante || 0}
                                // defaultValue={activeCond && activeCond.id_central == '1024' ? 's1' : 0} // temporário para a 'Minha Portaria'
                                options={[
                                    { id: 0, descricao: 'Tempo de Liberação' },
                                    { id: 's1', descricao: 'Liberar até a saída' },
                                    { id: 'm5', descricao: 'Liberar 5 minutos' },
                                    { id: 'm15', descricao: 'Liberar 15 minutos' },
                                    { id: 'm30', descricao: 'Liberar 30 minutos' },
                                    { id: 'h1', descricao: 'Liberar 1 hora' },
                                    { id: 'h3', descricao: 'Liberar 3 horas' },
                                    { id: 'h8', descricao: 'Liberar 8 horas' },
                                    { id: 'd1', descricao: 'Liberar 1 dia' },
                                    { id: 'd3', descricao: 'Liberar 3 dias' },
                                    { id: 'd7', descricao: 'Liberar 1 semana' }
                                ]}
                                onChange={handleChange}
                                name={"liberacao_padrao_visitante"}
                            />
                        </Grid>
                    </Grid>
                    <Grid container xs={12} md={12} sx={rowsSx}>
                        <Grid xs={12} md={3.5}>
                            <Typography fontSize="13px" fontWeight='400' >Notificar Morador: </Typography>
                        </Grid>
                        <Grid xs={12} md>
                            <OneSwitch
                                defaultValue={initialData?.notifica_morador_visitante}
                                onChange={handleChange}
                                name={"notifica_morador_visitante"}
                            />
                        </Grid>
                        <Grid xs={12} md={7}>
                            <Typography fontSize="13px" fontWeight='400'>Notifica morador sobre a liberação de acesso </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} >
                    <Grid xs={12} md={6}>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={3}>
                                <Typography fontSize="13px" fontWeight='400' >Divisões: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneInput
                                    defaultValue={initialData?.tipo_imovel}
                                    maxLength="20"
                                    onChange={handleChange}
                                    name={"tipo_imovel"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={3}>
                                <Typography fontSize="13px" fontWeight='400' >Tipo de Imóvel: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneInput
                                    defaultValue={initialData?.desc_tipo_imovel}
                                    maxLength="20"
                                    onChange={handleChange}
                                    name={"desc_tipo_imovel"}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} >
                    <Grid xs={12} md={12}>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={2}>
                                <Typography fontSize="13px" fontWeight='400' >Msg. Personalizada: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneSwitch
                                    defaultValue={initialData?.msg_personalizada}
                                    onChange={handleChange}
                                    name={"msg_personalizada"}
                                />
                            </Grid>
                            <Grid xs={12} md={9.2}>
                                <Typography fontSize="13px" fontWeight='400' >Permite escrever mensagens para envio no APP dos moradores: </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md={12}>
                        <Grid container xs={12} md={12} sx={rowsSx}>
                            <Grid xs={12} md={2}>
                                <Typography fontSize="13px" fontWeight='400' >Gerar contra senha: </Typography>
                            </Grid>
                            <Grid xs={12} md>
                                <OneSwitch
                                    defaultValue={initialData?.entrega_contra_senha}
                                    onChange={handleChange}
                                    name={"entrega_contra_senha"}
                                />
                            </Grid>
                            <Grid xs={12} md={9.2}>
                                <Typography fontSize="13px" fontWeight='400' >Solicita contra senha obrigatoria para liberar a entrega do morador </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} sx={{ padding: '4.5px' }}>
                    <Grid xs={12} md={1.5}>
                        <Typography fontSize="13px" fontWeight='400' >Observações: </Typography>
                    </Grid>
                    <Grid xs={12} md>
                        <OneTextArea
                            style={{ height: '100px' }}
                            defaultValue={initialData?.obs}
                            onChange={handleChange}
                            name={"obs"}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={2.6}>
                        <Typography fontSize="13px" fontWeight='400' >Notificar Obs: </Typography>
                    </Grid>
                    <Grid xs={12} md={0.6}>
                        <OneSwitch
                            defaultValue={initialData?.notif_obs}
                            onChange={handleChange}
                            name={"notif_obs"}
                        />
                    </Grid>
                    <Grid xs={12} md={8.8}>
                        <Typography fontSize="13px" fontWeight='400' >Sobe um lembrete no canto inferior direito toda vez que um condominio é selecionado </Typography>
                    </Grid>
                </Grid>

                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={2.6}>
                        <Typography fontSize="13px" fontWeight='400' >Fecha evento de visitante automaticamente: </Typography>
                    </Grid>
                    <Grid xs={12} md={0.6}>
                        <OneSwitch
                            defaultValue={initialData?.fecha_evento_visitante_automatico}
                            onChange={handleChange}
                            name={"fecha_evento_visitante_automatico"}
                        />
                    </Grid>
                    <Grid xs={12} md={8.8}>
                        <Typography fontSize="13px" fontWeight='400' >Fecha o evento de visitante automaticamente após a liberação
                            via facial do visitante
                        </Typography>
                    </Grid>
                </Grid>

                {([3, 4].includes(formData?.tipo_condominio) || [3, 4].includes(initialData?.tipo_condominio)) &&
                    <Grid container xs={12} md={12} sx={rowsSx}>
                        <Grid xs={12} md={2.8}>
                            <Typography fontSize="13px" fontWeight='400' >Gravar câmera por evento: </Typography>
                        </Grid>
                        <Grid xs={12} md={0.6}>
                            <OneSwitch
                                defaultValue={initialData?.gravar_camera_local}
                                onChange={handleChange}
                                name={"gravar_camera_local"}
                            />
                        </Grid>
                        {(formData?.gravar_camera_local || initialData?.gravar_camera_local) &&
                            <Grid container gap={1} xs md>
                                <Grid xs={12} md={1}>
                                    <OneInput
                                        defaultValue={initialData?.segundos_gravacao_local || 1}
                                        type="number"
                                        min="1"
                                        onChange={handleChange}
                                        name={"segundos_gravacao_local"}
                                    />
                                </Grid>
                                <Typography fontSize="13px" fontWeight='400' >segundos</Typography>
                            </Grid>
                        }
                    </Grid>
                }

                <Grid container xs={12} md={12} sx={rowsSx}>
                    <Grid xs={12} md={2.6}>
                        <Typography fontSize="13px" fontWeight='400' >OACC para Replays: </Typography>
                    </Grid>
                    <Grid xs={12} md={0.6}>
                        <OneSwitch
                            defaultValue={initialData?.grava_cams_oacc }
                            onChange={handleChange}
                            name={"grava_cams_oacc"}
                        />
                    </Grid>
                    <Grid xs={12} md={8.8}>
                        <Typography fontSize="13px" fontWeight='400' >
                            Grava imagens no VMS em OACCs desse condomínio, para ser usado em Replays no APP.
                        </Typography>
                    </Grid>
                    <Typography fontSize="13px" fontWeight='400' sx={{ color: '#f1970f' }}>
                        <b>Atenção:</b> Para a gravação de OACCs funcionar, é necessário também que a gravação esteja habilitada na configuração do evento OACC
                    </Typography>
                </Grid>
            </Grid>
            }
        </form>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="condominio-form" type="submit">Salvar</Button>
        </Grid>
    )
}
